import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ROUTES } from "../constants";
import { useAuth } from "../features/auth/hooks/useAuth";
import AppLayout from "./AppLayout";
import SignInPage from "../features/auth/pages/SignInPage";
import DashboardPage from "../features/dashboard/pages/DashboardPage";
import TrainingPlanPage from "../features/plan/pages/TrainingPlanPage";
import PrintablePlanPage from "../features/plan/pages/PrintablePlanPage";
import ExerciseDetailsPage from "../features/plan/pages/ExerciseDetailsPage";
import WorkoutToolsPage from "../features/dashboard/pages/WorkoutToolsPage";

function ProtectedRoute({ children }) {
  const { isAuthenticated, isClient, isLoading } = useAuth();
  if (isLoading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        Loading...
      </div>
    );
  }
  if (!isAuthenticated || !isClient) {
    return <Navigate to={ROUTES.SIGN_IN} replace />;
  }
  return children;
}

function PublicRoute({ children }) {
  const { isAuthenticated, isClient, isLoading } = useAuth();
  if (isLoading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        Loading...
      </div>
    );
  }
  if (isAuthenticated && isClient) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }
  return children;
}

export function AppRoutes() {
  return (
    <Routes>
      <Route path={ROUTES.HOME} element={<Navigate to={ROUTES.SIGN_IN} replace />} />
      <Route
        path={ROUTES.SIGN_IN}
        element={
          <PublicRoute>
            <SignInPage />
          </PublicRoute>
        }
      />
      <Route
        path={ROUTES.DASHBOARD}
        element={
          <ProtectedRoute>
            <AppLayout>
              <DashboardPage />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.TRAINING_PLAN}
        element={
          <ProtectedRoute>
            <AppLayout>
              <TrainingPlanPage />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.WORKOUT_TOOLS}
        element={
          <ProtectedRoute>
            <AppLayout>
              <WorkoutToolsPage />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.PRINTABLE_PLAN}
        element={
          <ProtectedRoute>
            <PrintablePlanPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={`${ROUTES.EXERCISE_DETAILS}/:exerciseId`}
        element={
          <ProtectedRoute>
            <AppLayout>
              <ExerciseDetailsPage />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to={ROUTES.SIGN_IN} replace />} />
    </Routes>
  );
}
